import {DRAG_TOGGLE} from 'constants/action-types.js';
import {MOUSE_DOWN} from 'constants/action-types.js';
import {COMMAND_DOWN} from 'constants/action-types.js';
import {SET_STEP_DRAGGING} from 'constants/action-types.js';
import {SET_KEYBOARD_CONTEXT} from 'constants/action-types.js';
import {SET_STEP_AND_DATA_DRAGGING} from 'constants/action-types.js';
import {SET_STEP_TO_COPY} from 'constants/action-types.js';
import {DRAG_STEP_TRANSPOSE} from 'constants/action-types.js';
import {SET_IS_DRAGGING_DURATION} from 'constants/action-types.js';
import {SET_STEP_DATA_DRAGGING} from 'constants/action-types.js';
import {SET_PIANO_ROLL_SELECTION} from 'constants/action-types.js';
import {SET_SELECTED_PIANO_ROLL_STEPS} from 'constants/action-types.js';
import {SET_STEPS_TO_COPY} from 'constants/action-types.js';
import {SET_EASY_PATTERN_TO_COPY} from 'constants/action-types.js';
import {SET_LAST_MIDI_KEY_MAPPED} from 'constants/action-types.js';
import {SET_TRANSPOSE_DRAGGING} from 'constants/action-types.js';
import {SET_PIANO_ROLL_PAGINATION} from 'constants/action-types.js';
import {SET_KEY_MAPPINGS} from 'constants/action-types.js';
import {SET_PAD_MAPPINGS} from 'constants/action-types.js';
import {SET_LAST_NOTE_PLAYED} from 'constants/action-types.js';
import {SET_PIANO_ROLL_DRAG_OFFSET} from 'constants/action-types.js';
import {SET_PIANO_ROLL_NOTES} from 'constants/action-types.js';
import {SET_PIANO_ROLL_CURSOR} from 'constants/action-types.js';
import {SET_NOTES_DOWN} from 'constants/action-types.js';
import {SET_PIANO_ROLL_SLIDE} from 'constants/action-types.js';
import {SET_PIANO_ROLL_LEFT_SPACE} from 'constants/action-types.js';

let initialState = {
    notes: [],
    pianoRollLeftSpace: 56,
    isDragToggled: false,
    dragStepTranspose: undefined,
    stepDragging: undefined,
    stepDataDragging: undefined,
    isDraggingDuration: false,
    stepToCopy: undefined,
    transposeDragging: undefined,
    isMouseDown: false,
    isCommandDown: false,
    pianoRollSelection: undefined,
    selectedPianoRollSteps: undefined,
    stepsToCopy: undefined,
    easyPatternToCopy: undefined,
    lastMidiKeyMapped: undefined,
    pianoRollPagination: undefined,
    keyMappings: {},
    padMappings: {},
    lastNotePlayed: undefined,
    dragOffset: undefined,
    cursor: undefined,
    notesDown: undefined,
};

const keyboardReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_KEYBOARD_CONTEXT:
        return {... state, keyboardContext: action.payload};
    case SET_NOTES_DOWN:
        return {... state, notesDown: action.payload};
    case DRAG_TOGGLE:
        return { ... state, isDragToggled: action.payload};
    case DRAG_STEP_TRANSPOSE:
        return { ... state, dragStepTranspose: action.payload};
    case MOUSE_DOWN:
        let isMouseDown = action.payload;
        return { ... state, isMouseDown: isMouseDown};
    case COMMAND_DOWN:
        return { ... state, isCommandDown: action.payload};
    case SET_PIANO_ROLL_SLIDE:
        return { ... state, pianoRollSlide: action.payload};
    case SET_STEP_DRAGGING:
        return { ... state, stepDragging: action.payload};
    case SET_STEP_TO_COPY:
        return { ... state, stepToCopy: action.payload};
    case SET_IS_DRAGGING_DURATION:
        return { ... state, isDraggingDuration: action.payload};
    case SET_PIANO_ROLL_NOTES:
        return { ... state, notes: action.payload};
    case SET_STEP_AND_DATA_DRAGGING:
        return {
            ... state,
            stepDataDragging: action.payload.stepData,
            stepDragging: action.payload.stepNumber
        };
    case SET_STEP_DATA_DRAGGING:
        return { ... state, stepDataDragging: action.payload};
    case SET_PIANO_ROLL_SELECTION:
        if (action.payload.stepNumber === undefined) {
            return { ... state, pianoRollSelection: undefined};
        }
        return { ... state, pianoRollSelection: action.payload};
    case SET_SELECTED_PIANO_ROLL_STEPS:
        // check if any of the current steps have p-locked parameters
        let steps = state.selectedPianoRollSteps;
        if (action.payload) {
            steps = steps || [];
            steps = [... steps, ...action.payload];
        }
        if (steps) { 
            if (steps.every(s => s && s.pLockedParameters.length > 0)) {
                // then we need to update all of these
                // this is horrible style btw. should actually find all of
                // the places that changes selected piano roll steps and do this there
                setTimeout(() => {
                    steps.filter(s => s.pLockedParameters.length > 0)
                        .forEach(s => s.pLockedParameters.forEach(
                            p => {
                                p.refresh(true, false, undefined, true);
                            }));
                }, 150);
            }
        }
        return { ... state, selectedPianoRollSteps: action.payload};
    case SET_STEPS_TO_COPY:
        return { ... state, stepsToCopy: action.payload};
    case SET_EASY_PATTERN_TO_COPY:
        return { ... state, easyPatternToCopy: action.payload};
    case SET_LAST_MIDI_KEY_MAPPED:
        return { ... state, lastMidiKeyMapped: action.payload};
    case SET_TRANSPOSE_DRAGGING:
        return { ... state, transposeDragging: action.payload.transpose};
    case SET_PIANO_ROLL_PAGINATION:
        return { ... state, pianoRollPagination: action.payload};
    case SET_KEY_MAPPINGS:
        return { ... state, keyMappings: action.payload};
    case SET_PAD_MAPPINGS:
        return { ... state, padMappings: action.payload};
    case SET_LAST_NOTE_PLAYED:
        return { ... state, lastNotePlayed: action.payload};
    case SET_PIANO_ROLL_DRAG_OFFSET:
        return { ... state, dragOffset: action.payload};
    case SET_PIANO_ROLL_CURSOR:
        return { ... state, cursor: action.payload};
    default:
        return state;
    }
};

export default keyboardReducer;
